<template>
  <div class="u-padding-xxsmall u-radius-g">
    <h6
      v-if="!isResult"
      @click="item.show = !item.show"
      class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
    >
      <div class="u-display-inline-flex u-align-items-center">
        <span
          class="u-margin-right-xsmall u-circle u-circle__variant--small"
          :class="`u-circle__variant--${
            validItemsCount === item.options.length || isResult
              ? 'success'
              : 'danger'
          }`"
        >
          <i
            :class="`icofont-${
              isResult
                ? 'check'
                : validItemsCount === item.options.length
                ? 'check'
                : 'close'
            }`"
          ></i>
        </span>
        <div>
          <div>
            {{ item.localesInfo[$i18n.locale] }}
            <span
              v-if="!isResult"
              class="u-margin-left-xsmall u-color-muted u-display-inline-block"
              >({{ validItemsCount }} / {{ item.options.length }})</span
            >
          </div>
        </div>
      </div>
      <i :class="`icofont-rounded-${item.show ? 'down' : 'right'}`"></i>
    </h6>

    <div class="u-padding-xxsmall u-margin-top-xxsmall row" v-if="item.show">
      <div
        :class="`es-xs-12 es-md-${col} u-padding-right-xsmall u-padding-left-xsmall`"
        v-for="(option, j) in item.options"
        :key="index + '-' + j"
      >
        <SelectBox
          v-if="option.type === 'select'"
          class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
          :childIndex="j"
          :index="index"
          :ref="`select-${index + '-' + j}`"
          optionField="key"
          @open="getOptions(option, j)"
          :options="
            getBatteryFeatureByFeatureType(
              form.type,
              option.requestKey.key + JSON.stringify(option.requestKey.query)
            )
          "
          :validActivated="validActivated"
          :label="optionLocalesInfo(option.localesInfo)"
          v-model="option.value"
        ></SelectBox>
        <BaseInput
          v-else
          block
          size="xs"
          class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
          :mandotary="validActivated"
          :readonly="isResult"
          :suffix="option.suffix || ''"
          v-model="option.value"
          :placeholder="
            isResult
              ? $t('batteries.resultWillbeCalculated')
              : $t('common.enterPlaceholder', {
                  label: optionLocalesInfo(option.localesInfo),
                })
          "
          :label="optionLocalesInfo(option.localesInfo)"
          :type="option.type"
        />
      </div>
    </div>
    <div v-if="item.bodyKey === 'dimensions'" class="u-margin-top-xsmall">
      <img src="@/assets/images/coil.jpg" width="100%" alt="" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import SelectBox from "@/components/Base/Inputs/SelectBox.vue";
export default {
  components: {
    BaseInput,
    SelectBox,
  },
  props: {
    col: {
      default: 0,
    },
    index: {
      default: 0,
    },
    form: {
      default: {},
    },
    item: {
      default: {},
    },
    validActivated: {
      default: false,
    },
    isResult: {
      default: false,
      type: Boolean,
    },
    isLast: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(["getBatteryFeatureByFeatureType"]),
    validItemsCount() {
      return this.item.options.filter((item) => item.value).length;
    },
  },
  methods: {
    getValidItemsCount() {
      return {
        validItemsCount: this.validItemsCount,
        totalCount: this.item.options.length,
        validation: this.validItemsCount === this.item.options.length,
      };
    },
    getOptions(option, subIndex) {
      const ref = this.$refs[`select-${this.index}-${subIndex}`][0];

      this.$emit("open", option, ref.search, ref.toggleLoading);
    },
    optionLocalesInfo(localesInfo) {
      return localesInfo[this.$i18n.locale];
    },
    filterMethods(options, search) {
      return options.filter((option) =>
        (option.title || option.key)
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
